import { message } from 'antd';

import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'
import { getMrtSubmittedForverificationAPI } from '../../../services/mrt-service';

import {
    FETCH_SUBMITTED_FOR_VERIFICATION,
    FETCH_SUBMITTED_FOR_VERIFICATION_START,
    FETCH_SUBMITTED_FOR_VERIFICATION_SUCCESS,
    FETCH_SUBMITTED_FOR_VERIFICATION_ERROR,
    SET_MRT_SFV_FILTER,
    SET_SUBMITTED_FOR_VERIFICATION_PAGINATION
    // UNDO_REVIEWING_REPORT,
    // UNDO_REVIEWING_REPORT_START,
    // UNDO_REVIEWING_REPORT_SUCCESS,
    // UNDO_REVIEWING_REPORT_ERROR,
} from "../../actions/mrt/submittedForVerificationAction";

function* fetchSubmittedForVerificationVisits({ payload }) {
    try {
        yield put({ type: FETCH_SUBMITTED_FOR_VERIFICATION_START })
        const response = yield call(getMrtSubmittedForverificationAPI, payload);
        if (response.success) {
            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            yield put({ type: FETCH_SUBMITTED_FOR_VERIFICATION_SUCCESS, submittedForVerification: response.data.mrtSubmittedForVerification });
            yield put({ type: SET_MRT_SFV_FILTER, payload: { ...payload } });
            yield put({ type: SET_SUBMITTED_FOR_VERIFICATION_PAGINATION, pagination });
        } else {
            yield put({ type: FETCH_SUBMITTED_FOR_VERIFICATION_ERROR, error: response.error })
            message.error('Failed to fetch review pending reports!');
        }
    } catch (error) {
        yield put({ type: FETCH_SUBMITTED_FOR_VERIFICATION_ERROR, error })
        message.error('Failed to fetch review pending reports!');
    }
}

// function* undoReviewingReport({ payload }) {
//     try {
//         const { reportId } = payload;
//         yield put({ type: UNDO_REVIEWING_REPORT_START })
//         const response = yield call(undoReviewingReportAPI, payload);
//         if (response.success) {
//             yield put({ type: UNDO_REVIEWING_REPORT_SUCCESS, reportId });
//             message.success('Undo successfully!');
//         } else {
//             if (response.error) {
//                 yield put({ type: UNDO_REVIEWING_REPORT_ERROR, error: response.error })
//                 message.error(response.error);
//             } else {
//                 yield put({ type: UNDO_REVIEWING_REPORT_ERROR, error: response.error })
//                 message.error('Failed to undo reviewing report!');
//             }
//         }
//     } catch (error) {
//         yield put({ type: UNDO_REVIEWING_REPORT_ERROR, error })
//         message.error('Failed to undo reviewing report!');
//     }
// }

function* submittedForVerificationWatcher() {
    yield takeEvery(FETCH_SUBMITTED_FOR_VERIFICATION, fetchSubmittedForVerificationVisits)
    // yield takeLatest(UNDO_REVIEWING_REPORT, undoReviewingReport)
}

export default function* rootSaga() {
    yield all([
        submittedForVerificationWatcher(),
    ]);
}